/* eslint-disable @typescript-eslint/no-unsafe-call */
import React from "react";
import "react-toastify/dist/ReactToastify.css";
import "./styles/styles.scss";
import { ToastContainer } from "react-toastify";
import { ModalProvider } from "./components/modal/Modal.component";
import { AppComponent } from "./components/app/App.component";
import { MenuProvider } from "./components/menu/useMenu";
import { createRoot } from "react-dom/client";

const container = document.getElementById("mainBody");
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <MenuProvider>
      <ModalProvider>
        <AppComponent />
      </ModalProvider>
    </MenuProvider>
    <ToastContainer />
  </React.StrictMode>,
);
